import { render, staticRenderFns } from "./ProjectUpdate.vue?vue&type=template&id=6c5a99f8"
import script from "./ProjectUpdate.vue?vue&type=script&lang=js"
export * from "./ProjectUpdate.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports